import React, { useState } from 'react';
import './RatingComponent.css';

const RatingComponent = ({ onSubmit, onCancel, isLoading, currentRating }) => {
    const [selectedRating, setSelectedRating] = useState(currentRating || 0);
    const [hoverRating, setHoverRating] = useState(0);

    const handleStarClick = (rating) => {
        setSelectedRating(rating);
    };

    const handleStarHover = (rating) => {
        setHoverRating(rating);
    };

    const handleStarLeave = () => {
        setHoverRating(0);
    };

    const handleSubmit = () => {
        if (selectedRating > 0) {
            onSubmit(selectedRating);
        }
    };

    const getRatingText = (rating) => {
        switch (rating) {
            case 1:
                return 'Muy malo';
            case 2:
                return 'Malo';
            case 3:
                return 'Regular';
            case 4:
                return 'Bueno';
            case 5:
                return 'Excelente';
            default:
                return 'Selecciona una calificación';
        }
    };

    const displayRating = hoverRating || selectedRating;

    return (
        <div className="rating-overlay">
            <div className="rating-modal">
                <div className="rating-header">
                    <h3>Evalúa tu experiencia</h3>
                    <p>¿Cómo calificarías tu estadía?</p>
                </div>

                <div className="rating-content">
                    <div className="stars-container">
                        {[1, 2, 3, 4, 5].map((star) => (
                            <button
                                key={star}
                                type="button"
                                className={`star-button ${
                                    star <= displayRating ? 'active' : ''
                                } ${
                                    hoverRating > 0 && star <= hoverRating ? 'hover' : ''
                                }`}
                                onClick={() => handleStarClick(star)}
                                onMouseEnter={() => handleStarHover(star)}
                                onMouseLeave={handleStarLeave}
                                disabled={isLoading}
                            >
                                ★
                            </button>
                        ))}
                    </div>

                    <div className="rating-text">
                        <span className={`rating-description ${
                            displayRating > 0 ? 'visible' : ''
                        }`}>
                            {getRatingText(displayRating)}
                        </span>
                    </div>

                    {selectedRating > 0 && (
                        <div className="rating-feedback">
                            <p>Has seleccionado {selectedRating} estrella{selectedRating !== 1 ? 's' : ''}</p>
                        </div>
                    )}
                </div>

                <div className="rating-actions">
                    <button
                        type="button"
                        onClick={onCancel}
                        className="btn-cancel"
                        disabled={isLoading}
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        onClick={handleSubmit}
                        className="btn-submit"
                        disabled={selectedRating === 0 || isLoading}
                    >
                        {isLoading ? (
                            <>
                                <span className="loading-spinner-small"></span>
                                Guardando...
                            </>
                        ) : (
                            currentRating ? 'Actualizar Evaluación' : 'Enviar Evaluación'
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RatingComponent;